import { Container, Stack, Title } from "@mantine/core";
import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import { RunnersSection } from "../features/runners/RunnersSection";

// Страница «Настройки → Раннеры» (ADR-0073). Тонкий контейнер над
// секцией регистрации/списка/перевыпуска токена — как
// `SettingsSessionsPage`.
export function SettingsRunnersPage(): ReactElement {
  const { t } = useTranslation();
  return (
    <Container py="xl">
      <Stack gap="xl">
        <Title order={1}>{t("runners.pageTitle")}</Title>
        <RunnersSection />
      </Stack>
    </Container>
  );
}
